import Vue from 'vue'
import Vuex from 'vuex'
import actions from './actions'
import mutations from './mutations'
import getters from './getters'
Vue.use(Vuex)
const store = new Vuex.Store({
  state: {
    isShowExchange: false,
    isRecordProgress: true,
    sessionToken: null,
    user: null // 用户信息
  },
  mutations,
  actions,
  getters,
})
export default store
